export default __webpack_public_path__ + "static/media/reward-per-action-2.60f13e2d.png";